import { LeadLog } from "../../../../../types"
import { Badge } from "../../../../ui"

type Props = {
  info: LeadLog
  onClick: (id: string) => void
}

const LeadsCell = ({ info, onClick }: Props) => {
  const { name = "Unnamed", email, resthook_status, id } = info

  return (
    <td className="whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer">
      <div className="flex items-center">
        <div
          className="font-bold mr-2 hover:border-b border-neutral-500 leading-none"
          onClick={() => onClick(id)}
        >
          {name}
        </div>
        {resthook_status && <Badge.Info>{resthook_status}</Badge.Info>}
      </div>
      <div className="text-neutral-400 text-sm">{email}</div>
    </td>
  )
}

export default LeadsCell
